import withStyles from '@mui/styles/withStyles';
import ButtonGroup from '@mui/material/ButtonGroup';
import {Theme} from '@mui/material'

export const TopNavBarButtonGroup = withStyles((theme: Theme) => ({
	root: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.common.white,
		borderRadius: 10,
		borderColor: theme.palette.primary.dark,
		textTransform: 'none',
		minHeight: 32,
		maxHeight: 32,
	},
	groupedOutlined: {
		//fixes separating border not visible when using background color
		'&:not(:first-child)': {
			borderLeftColor: theme.palette.primary.dark,
		},
	},
}), {name: 'TopNavBarButtonGroup'})(ButtonGroup) as typeof ButtonGroup;